module.exports = {
        srcSet: __webpack_public_path__ + "static/media/rent_legal_mobile-639.0a0a8af2.webp"+" 639w",
        images: [{path: __webpack_public_path__ + "static/media/rent_legal_mobile-639.0a0a8af2.webp",width: 639,height: 426}],
        src: __webpack_public_path__ + "static/media/rent_legal_mobile-639.0a0a8af2.webp",
        toString: function(){return __webpack_public_path__ + "static/media/rent_legal_mobile-639.0a0a8af2.webp"},
        
        width: 639,
        height: 426
      }